function initUgearsMap() {
  var mapEl = document.getElementById('store-locator-map');
  var listEl = document.getElementById('store-list');
  if (!mapEl) return;

  var storesJson = mapEl.getAttribute('data-stores');
  var stores = [];
  try {
    stores = JSON.parse(storesJson);
  } catch (e) {
    console.log('Failed to parse stores JSON', e);
  }

  var collator = new Intl.Collator('fi');
  stores.sort(function(a, b) {
    return collator.compare(a.name, b.name);
  });

  if (listEl) {
    listEl.innerHTML = '';
    stores.forEach(function(store, i) {
      var div = document.createElement('div');
      div.className = 'store-list-item';
      div.setAttribute('data-index', i);
      div.style.padding = '14px 14px 14px 0';
      div.style.borderBottom = '1px solid #e5e5e5';
      div.style.cursor = 'pointer';
      div.innerHTML = '<strong>' + store.name + '</strong><br><span style="color:#666;font-size:14px;">' + store.address + ', ' + store.postcode + ' ' + store.city + '</span>';
      listEl.appendChild(div);
    });
  }

  var map = L.map('store-locator-map');
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; OpenStreetMap contributors',
    maxZoom: 19
  }).addTo(map);

  var ugearsIcon = L.icon({
    iconUrl: mapEl.getAttribute('data-icon-url'),
    iconSize: [40, 40],
    iconAnchor: [20, 20]
  });

  var markers = [];
  stores.forEach(function(store) {
    var marker = L.marker([store.lat, store.lng], { icon: ugearsIcon }).addTo(map);
    var directionsUrl = 'https://www.google.com/maps/dir/?api=1&destination=' + store.lat + ',' + store.lng;
    marker.on('click', function() {
      window.open(directionsUrl, '_blank', 'noopener');
    });
    markers.push(marker);
  });

  document.querySelectorAll('.store-list-item').forEach(function(item) {
    item.addEventListener('click', function() {
      var idx = parseInt(item.getAttribute('data-index'));
      var store = stores[idx];
      map.setView([store.lat, store.lng], 15);
    });
  });

  if (markers.length > 0) {
    var group = new L.featureGroup(markers);
    map.fitBounds(group.getBounds().pad(0.2));
  } else {
    map.setView([64.0, 26.0], 5);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initUgearsMap);
} else {
  initUgearsMap();
}